import { render, staticRenderFns } from "./GraphsOfficer.vue?vue&type=template&id=2d2837c7&scoped=true"
import script from "./GraphsOfficer.vue?vue&type=script&lang=js"
export * from "./GraphsOfficer.vue?vue&type=script&lang=js"
import style0 from "./GraphsOfficer.vue?vue&type=style&index=0&id=2d2837c7&prod&scoped=true&lang=css"
import style1 from "./GraphsOfficer.vue?vue&type=style&index=1&id=2d2837c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2837c7",
  null
  
)

export default component.exports